// Pemberitahuan sekilas untuk aksi yang sudah terjadi — tersimpan, terhapus,
// terkirim. Dipakai untuk hasil aksi; pesan yang harus dibaca sebelum
// melanjutkan (validasi formulir) tetap tampil di tempatnya, bukan di sini,
// karena toast menghilang sendiri.
import { defineStore } from 'pinia'

export type ToastJenis = 'sukses' | 'galat' | 'info'

export interface Toast {
  id: number
  jenis: ToastJenis
  pesan: string
}

// Galat diberi waktu lebih lama: pembacanya perlu sempat memahami apa yang
// gagal, sedangkan konfirmasi keberhasilan cukup sekilas.
const DURASI: Record<ToastJenis, number> = { sukses: 3500, info: 4000, galat: 6000 }

let urut = 0

export const useToastStore = defineStore('toast', {
  state: () => ({ items: [] as Toast[] }),
  actions: {
    tampilkan(pesan: string, jenis: ToastJenis = 'sukses') {
      const id = ++urut
      this.items.push({ id, jenis, pesan })
      window.setTimeout(() => this.tutup(id), DURASI[jenis])
      return id
    },
    sukses(pesan: string) {
      return this.tampilkan(pesan, 'sukses')
    },
    galat(pesan: string) {
      return this.tampilkan(pesan, 'galat')
    },
    info(pesan: string) {
      return this.tampilkan(pesan, 'info')
    },
    tutup(id: number) {
      this.items = this.items.filter((t) => t.id !== id)
    },
  },
})
